import { memo, useCallback } from 'react';
import { IconChevronRight, IconLayoutList } from '@tabler/icons-react';
import { Popover } from '@headlessui/react';
import SceneOptionsSpeakersSubMenu from './SceneOptionsMenuSpeakersSubMenu';
import { SCENE_OPTION_MENU_ITEM_COMMON_CLASSNAME } from '../SceneOptionsMenuConstants';
import { useSceneTracks } from './useSceneTracks';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { usePopoverPosition } from '@/hooks/usePopoverPosition';
import { Scene } from '@/player-config/src/types/RemotionPlayerConfigTypes/Scene';
import { getClipBroadcastId } from '@/player-config/src/utils/clipUtils';

function SceneOptionsMenuSpeakers({
  sceneId,
  scenes,
  compositeSegmentId
}: {
  sceneId: string;
  scenes: Scene[];
  compositeSegmentId: string;
}) {
  const { popoverRef, position } = usePopoverPosition();
  const { clipId, clipData } = useClipsContext();
  const broadcastId = getClipBroadcastId(clipData)!;

  const { tracksToRender, handleTrackToggle } = useSceneTracks({
    broadcastId,
    clipId,
    sceneId,
    scenes,
    compositeSegmentId
  });

  const handleMouseEnter = useCallback(() => {
    if (popoverRef.current) {
      const button = popoverRef.current.querySelector('button');
      if (button) {
        button.click();
      }
    }
  }, [popoverRef]);

  return (
    <Popover className="relative w-full" ref={popoverRef}>
      <Popover.Button className={`${SCENE_OPTION_MENU_ITEM_COMMON_CLASSNAME}`} onMouseEnter={handleMouseEnter}>
        <div className="flex items-center gap-2">
          <IconLayoutList className="size-4" />
          <div>Tracks</div>
        </div>
        <IconChevronRight className="size-4" />
      </Popover.Button>
      <Popover.Panel
        className="absolute z-[9999] w-48 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none"
        style={{
          [position === 'right' ? 'left' : 'right']: 'calc(100% + 4px)',
          bottom: '0'
        }}
      >
        <SceneOptionsSpeakersSubMenu tracks={tracksToRender} onToggleTrack={handleTrackToggle} />
      </Popover.Panel>
    </Popover>
  );
}

export default memo(SceneOptionsMenuSpeakers);
